import React from 'react';
import {useAppStateContext} from '../../../providers/AppState';
import {useAccessRight} from '../../../controllers/useAccessRight';
import {
  PerformanceUnbilledReportTable,
  PerformanceUnbilledReportUnAssignedTable,
} from '../../pmt/views/PerformanceReportTable';
import {createMenuNavigator} from '../../../components/menu/MenuNavigator';
import {NewProjectUnbilledTab} from './NewProjectTab';

const ProjectGroup = createMenuNavigator();
export const ProjectsUnbilledNavigator = props => {
  const {
    route: {params},
  } = props;
  const {user, globalData: {accessRights: userAccessRights} = {}} =
    useAppStateContext();
  const canAccess = useAccessRight({accessRights: userAccessRights});
  return (
    <ProjectGroup.Navigator
      canAccess={canAccess}
      data-navigator-id="ProjectGroup"
      {...props}>
      <ProjectGroup.Screen
        data-resource-id="ProjectBilledNew"
        name="New"
        props={{user: user, ...props}}
        component={NewProjectUnbilledTab}
        options={{
          label: 'New',
        }}
      />
      <ProjectGroup.Screen
        data-resource-id="ProjectBilledUnassigned"
        name="Unassigned"
        component={PerformanceUnbilledReportUnAssignedTable}
        props={{
          filter: {
            project_status: 'a',
            projecttype: 'i',
            is_project_assign: {$in: [null, false]},
          },
          tab: 'Unassigned',
          project_status: 'a',
          tabName: 'unbilled',
        }}
        options={{
          label: 'Unassigned(Active)',
        }}
      />
      <ProjectGroup.Screen
        data-resource-id="ProjectBilledAssigned"
        name="Assigned"
        component={PerformanceUnbilledReportTable}
        props={{
          filter: {
            project_status: 'a',
            projecttype: 'i',
            is_project_assign: true,
          },
          tab: 'Assigned',
          project_status: 'a',
          tabName: 'unbilled',
        }}
        options={{
          label: 'Assigned(Active)',
        }}
      />
      <ProjectGroup.Screen
        data-resource-id="ProjectHold"
        name="On-Hold-unbilled"
        props={{
          filter: {
            project_status: 'h',
            projecttype: 'i',
          },
          tab: 'On-hold',
          project_status: 'h',
          tabName: 'unbilled',
        }}
        component={PerformanceUnbilledReportTable}
        options={{
          label: 'On-Hold',
        }}
      />
      <ProjectGroup.Screen
        data-resource-id="ProjectCompleted"
        name="Completed-unbilled"
        props={{
          filter: {
            project_status: 'c',
            projecttype: 'i',
          },
          tab: 'Completed',
          project_status: 'c',
          tabName: 'unbilled',
        }}
        component={PerformanceUnbilledReportTable}
        options={{
          label: 'Closed',
        }}
      />
    </ProjectGroup.Navigator>
  );
};
